import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivitySummaryCard = ({ activity }) => {
  const typeColors = {
    registration: 'bg-primary/10 text-primary',
    match: 'bg-success/10 text-success',
    reveal: 'bg-accent/10 text-accent',
    flag: 'bg-warning/10 text-warning',
    subscription: 'bg-secondary/10 text-secondary'
  };

  return (
    <div className="flex items-start gap-3 py-3 border-b border-border last:border-0">
      <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${
        typeColors?.[activity?.type] || 'bg-muted text-muted-foreground'
      }`}>
        <Icon name={activity?.icon} size={16} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-foreground truncate">{activity?.user}</p>
        <p className="text-xs text-muted-foreground">{activity?.action}</p>
      </div>
      <span className="text-xs text-muted-foreground whitespace-nowrap">{activity?.time}</span>
    </div>
  );
};

export default ActivitySummaryCard;